<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes lateral-lunge-1 {
    0% {
      opacity: 1;
    }
    25%,
    75% {
      opacity: 0;
    }
    50%,
    75% {
      opacity: 1;
    }
    75%,
    100% {
      opacity: 0;
    }
  }
  #lateral-lunge-1 {
    animation-name: lateral-lunge-1;
  }
  @keyframes lateral-lunge-2 {
    0%,
    25% {
      opacity: 0;
    }
    25%,
    50% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #lateral-lunge-2 {
    animation-name: lateral-lunge-2;
  }
  @keyframes lateral-lunge-3 {
    0%,
    75% {
      opacity: 0;
    }
    75%,
    100% {
      opacity: 1;
    }
  }
  #lateral-lunge-3 {
    animation-name: lateral-lunge-3;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 544.4 620.8" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="lateral-lunge-3">
      <path
        fill="var(--flesh)"
        d="M397 202c1-3 2-5 0-7-6-6-6-15-8-22-2-4 3-3 5-4l4 21c3-4 3-8 6-11s1-8 1-12c1-3 2-3 4-3l14 4c13 3 26 6 38-3 3-2 4 0 4 2v11h1l3-10c3 2 3 4 2 8-5 11-13 22-14 36-3 2-4 6-7 9-3 4 0 12 4 14 7 2 10 7 8 13-3 7-1 15-2 23 0 4 1 6 3 8 9 10 20 16 30 25 2 2 6 2 9-1 8-6 16-11 26-8a9 9 0 0 0 2 0c-1 6 3 10 5 15l7 21a4 4 0 0 0 2 4v24l-3 4c-6 7-12 8-21 4-15-6-26-18-37-30l-18-20c-3-7-9-11-12-16-5-9-12-15-18-22-1-1-3-2-4-1-4 5-12 7-16 13-8 13-18 23-26 36-6 9-13 17-21 24-7 7-15 14-25 16l-6 2c-6 3-10 2-14-3a49 49 0 0 1-4-9c-2-4-1-8-3-11-3-14 2-27 1-40 0-2 1-4-1-5 9-9 17-17 31-16 8 1 16 8 16 16 0 2-1 4 1 5 7-4 13-9 19-15a230 230 0 0 1 19-16c5-4 7-7 4-13l-3-9c0-4-5-8-2-12 2-4 2-7-1-10-3-5-3-10-3-16 1-4 2-9 0-13ZM316 431c-6 3-9 9-14 14-14 13-28 26-45 34a53 53 0 0 0-21 19c-11 17-27 26-44 35-10 5-20 11-26 20l-7 5c-3 1-5 2-5-1 0-6-3-8-6-12l22-29 24-31c6-8 14-11 22-16l28-25c9-7 13-16 16-26a10 10 0 0 1 4-6c16 1 32 6 49 8 8 1 8 1 3 9v2ZM456 553c3-12 1-23-1-35-4-16-4-32 1-48l2-13a5 5 0 0 0 0-4 96 96 0 0 0-17-20c-1-8-7-12-12-16s-4-6 0-8l13-8c12-9 25-12 39-4h3a31 31 0 0 1 3 13c0 9 7 15 7 23 1 19 6 39 1 58l-14 46-3 11c-7-1-14-4-18 5-1 0-2 2-4 0Z"
      />
      <path
        fill="var(--shirt)"
        d="M343 367c10-2 18-9 25-16 8-7 15-15 21-24 8-13 18-23 26-36 4-6 11-8 16-13 1-1 3 0 4 1 6 7 13 13 18 22 3 5 9 9 12 16-3 5-6 10-11 14a7 7 0 0 0-2 7c-3 1-2 4-3 6l-4 5-33 21c-7 4-16 6-21 13a37 37 0 0 1-13 1c-7-4-15-6-23-9-4-2-9-4-12-8ZM397 202c2 4 1 9 0 13 0 6 0 11 3 16 3 3 3 6 1 10-3 4 2 8 2 12l3 9c3 6 1 9-4 13a230 230 0 0 0-19 16c-6 6-12 11-19 15-2-1-1-3-1-5 0-8-8-15-16-16-14-1-22 7-31 16-4 1-6-1-6-5a16 16 0 0 1 4-10c7-9 10-20 14-31 7-21 21-33 41-40l28-13Z"
      />
      <path
        fill="var(--pants)"
        d="M343 367c3 4 8 6 12 8 8 3 16 5 23 9l-22 50c-2 3-4 4-8 3-10-4-21-5-32-6v-2c5-8 5-8-3-9l-49-9c0-5 4-9 7-13l19-27 10-9c5-6 9-12 16-16 2 3 1 7 3 11a49 49 0 0 0 4 9c4 5 8 6 14 3l6-2Z"
      />
      <path
        fill="var(--shirt)"
        d="M529 295a9 9 0 0 1-1 0c-10-3-18 2-26 8-3 3-7 3-9 1-10-9-21-15-30-25-2-2-3-4-3-8 1-8-1-16 2-24 2-5-1-10-8-12-5-2-7-10-4-14 2-3 4-7 7-9 10 1 18 7 26 12 16 11 32 23 39 42 3 5 8 9 11 15s2 9-4 14Z"
      />
      <path
        fill="var(--pants)"
        d="M391 383c5-7 14-9 21-13l33-21 4-5c1-2 0-5 3-6 1 5 5 8 5 14 1 3 5 7 9 8 2 0 4 0 4 3-1 10 6 16 9 24l5 10h-3c-14-8-27-5-39 4l-13 8c-4 3-5 4 0 8s11 8 12 16l-7 5c-11 6-18 4-23-7l-20-48Z"
      />
      <path
        fill="var(--hair)"
        d="m469 168-3 10h-1v-11c0-2-1-4-4-2-12 9-25 6-38 3l-14-4c-2 0-4 0-4 3 0 4 2 9-1 12s-3 7-6 11l-4-21c-3-15 1-29 8-42 5-9 12-15 23-14a82 82 0 0 0 16 0c18-2 35 22 31 38l-3 17ZM456 553c2 2 3 0 4 0 4-9 11-6 18-5 3 2 4 4 5 8 0 8 5 15 9 21l10 11c7 8 3 20-7 22-13 3-25-2-32-12-5-8-7-17-14-23-2-2-1-5 1-8 3-3 5-7 3-12l1-2a13 13 0 0 1 2 0ZM148 545c3 4 6 6 6 12 0 3 3 3 5 1l7-5c-2 6-3 13-3 20 0 4-3 8-7 9-5 3-9 8-13 12-7 9-17 14-29 13s-16-10-9-20c3-5 7-9 12-12 7-5 12-11 16-19 2-5 6-7 9-11 1-2 4 0 6 0Z"
      />
    </g>
    <g id="lateral-lunge-2">
      <path
        fill="var(--flesh)"
        d="M147 211c-1-3-1-5 1-7 6-6 5-15 8-22 1-4-3-3-6-4l-4 21c-2-4-2-8-6-11-3-3-1-8-1-12 0-3-2-3-4-2l-13 3c-13 3-27 6-39-3-2-2-3 0-3 2v11h-1l-3-10c-4 2-4 4-2 8 5 12 12 22 13 36 4 2 5 6 7 9 3 4 1 12-4 14-6 2-10 7-8 13 3 8 2 15 3 23 0 4-1 6-4 9-8 9-20 16-29 24-3 2-7 2-10-1-7-6-15-11-26-8a9 9 0 0 1-1 0c1 6-4 10-6 16-2 7-5 13-6 21a4 4 0 0 1-3 3v24l4 4c5 7 11 8 20 5 16-7 26-19 37-31l18-20c3-6 9-10 12-16 5-9 12-15 19-22l3-1c5 5 12 8 16 13 8 13 18 24 26 36 6 9 13 17 21 24 7 7 15 14 26 16l5 2c6 3 10 2 14-3a49 49 0 0 0 5-9c1-4 0-8 3-11 2-14-3-27-1-40v-5c-8-9-17-17-31-16-8 1-15 8-16 16 0 2 1 4-1 5-7-4-13-9-19-15a228 228 0 0 0-18-16c-6-4-7-7-5-13l3-9c0-4 5-8 3-12-3-4-2-6 0-10 3-5 3-10 3-16v-13ZM228 440c6 3 10 9 15 14 13 13 27 26 45 34a53 53 0 0 1 21 19c10 17 27 27 44 35 9 5 19 11 26 20l6 5c2 1 5 2 5-1 0-5 4-8 7-11l-23-30-24-31c-5-7-14-11-21-16-11-7-19-17-29-25-8-7-12-16-15-26a10 10 0 0 0-4-6c-17 1-33 6-49 8-9 1-9 1-4 9v2ZM88 563c-2-12-1-24 2-36 3-16 3-32-1-48l-3-13a5 5 0 0 1 1-4 96 96 0 0 1 16-20c1-8 7-12 12-16s4-5 0-8l-13-8c-12-9-25-12-39-3l-2-1a31 31 0 0 0-3 14c0 8-7 14-8 22-1 19-6 39 0 58l13 46 3 11c7-1 14-4 19 5 0 0 2 2 3 1Z"
      />
      <path
        fill="var(--shirt)"
        d="M202 376c-11-2-19-9-26-16s-15-15-21-24c-8-12-18-23-26-36-4-5-11-8-16-13l-3 1c-7 7-14 13-19 22-3 6-9 10-12 16l11 14a7 7 0 0 1 2 7c3 1 3 4 4 6l3 6 34 20c7 4 15 6 20 13a37 37 0 0 0 13 2c7-5 15-7 23-10 5-2 9-4 13-8ZM147 211v13c0 6 0 11-3 16-2 4-3 6 0 10 2 4-3 8-3 12l-3 9c-2 6-1 9 5 13a228 228 0 0 1 19 16c6 6 11 12 18 15 2-1 1-3 1-5 1-8 8-15 17-16 13-1 22 7 31 16 4 1 5-1 5-5a16 16 0 0 0-3-10c-8-9-11-20-14-31-8-20-22-32-42-40-9-3-18-9-28-13Z"
      />
      <path
        fill="var(--pants)"
        d="M202 376c-4 4-8 6-13 8-8 3-16 5-23 10l23 49c1 3 3 4 7 3 10-4 21-5 32-6v-2c-5-8-5-8 4-9 16-2 32-7 49-8-1-6-4-10-7-14l-20-27c-2-4-6-6-9-9-6-5-10-12-16-16-3 3-2 7-3 11a49 49 0 0 1-5 9c-4 5-8 6-14 3l-5-2Z"
      />
      <path
        fill="var(--shirt)"
        d="M15 304a9 9 0 0 0 1 0c10-3 19 2 26 8 3 3 7 3 10 1 9-8 21-15 29-24 3-3 4-5 3-9 0-8 1-15-2-23-2-6 2-11 8-13 5-2 7-10 4-14-2-3-3-7-7-9-10 1-18 7-26 12a95 95 0 0 0-39 42c-2 5-7 10-10 15-4 6-3 9 3 14Z"
      />
      <path
        fill="var(--pants)"
        d="M153 392c-5-7-13-9-20-13-12-6-23-13-34-21-2-1-3-3-3-5s-1-5-4-6c-1 5-5 9-5 14 0 3-4 7-9 8-2 0-4 0-4 3 2 10-5 16-9 24l-4 10 2 1c14-9 27-6 39 3l13 8c4 3 5 4 0 8s-11 8-12 16l7 5c11 6 18 4 23-7l20-48Z"
      />
      <path
        fill="var(--hair)"
        d="m76 177 3 10h1v-11c0-2 1-4 3-2 12 9 26 6 39 3l13-4c2 0 4 0 4 3 0 4-2 9 1 12 4 3 4 7 6 11l4-21c4-15 0-29-8-42-5-9-12-15-23-14a82 82 0 0 1-15 0c-19-2-36 22-32 38l4 17ZM88 563c-1 1-3 0-3-1-5-9-12-6-19-5-3 2-4 4-4 8 0 8-5 15-10 21l-10 11c-7 8-3 20 7 22 13 3 26-1 33-12 5-8 7-17 13-23 2-2 2-5 0-8-3-3-6-7-4-12v-2a13 13 0 0 0-3 1ZM397 555c-3 3-7 6-7 11 0 3-3 3-5 1l-6-5c1 7 3 13 2 20 0 5 4 8 7 10 6 2 9 7 13 12 8 9 17 13 29 12s17-10 10-20c-3-5-8-9-13-12-6-5-12-11-15-19-2-5-7-7-9-11-1-1-4 1-6 1Z"
      />
    </g>
    <g id="lateral-lunge-1">
      <path
        fill="var(--hair)"
        d="M403 621c-15-4-19-13-18-28 1-4-1-7-4-10-5-4-6-8-3-13s-1-9 1-13c2 2 4 5 6 1 4-6 9-5 14-5 5 2 11 4 9 12-1 1 1 4 2 6 6 10 9 20 12 31 3 10-2 16-12 18l-2 1ZM109 586c7-11 16-21 17-34 1-5 4-8 8-11 5 1 10 2 12 8 0 2 1 3 3 2a4 4 0 0 0 3-2l2-6c1 6 2 12 5 18 2 4 1 7-3 9-1 1-2 3-4 3-5 3-6 7-6 14 2 12-2 16-10 20-10 4-21 1-27-7ZM230 52c-1-9-2-18-1-27a8 8 0 0 0 0-5c-4-6-1-9 4-12a65 65 0 0 1 20-7l3-1h5c2 2 6 1 9 2 4 2 9 3 10 8 1 3 4 2 5 3 4 2 7 4 6 8-2 10 2 20-1 30-2 3-1 8-5 11 1-8 2-16-4-23l-1-3c0-8-4-11-11-9s-16 2-24 0c-5-2-8 0-8 6a4 4 0 0 1-2 4c-3 2-3 5-2 9 0 4 2 9 1 14-3-2-3-5-4-8Z"
      />
      <path
        fill="var(--shirt)"
        d="M162 179c-2-1-1-3-1-5 4-16 8-32 14-48a19 19 0 0 1 10-10l43-17c3 0 5 1 6 3l11 11c4 4 8 5 12 3l10-2c7-2 15-4 18-11 1-4 3-4 5-4l41 16c6 2 8 8 10 12 7 13 12 27 18 40 1 4 1 8-4 10-1-3-2-3-5-2-7 4-12 11-20 13a14 14 0 0 0-7 4c-3-1-2-6-5-7 1 21 3 41 2 61-1 21 4 41 12 61 1 3 1 5-2 8-7 0-13 3-19 5-15 5-29 3-44 3-22 1-44 0-66-2-5-1-7-3-5-8-1-21 3-42 5-63 1-9 3-18 2-27s-3-17-2-26c0-1 0-3-2-3 0-3 2-4 0-8 0 7-2 6-5 3s-5-6-10-3c-2 1-4 0-6-1-5-2-10-7-16-6Z"
      />
      <path
        fill="var(--pants)"
        d="M196 313c-2 5 0 7 5 8 22 2 44 3 66 2 15 0 29 2 44-3 6-2 12-5 19-5l6 19c-2 4-8 7-9 13s-1 12-4 18c0 2-1 3 1 4 2 2 4 0 5-2a108 108 0 0 0 6-10c1-2 1-4 4-3 2 1 2 2 2 4l-2 6-8 11c-1 1-3 3-2 6a7 7 0 0 0 7 1l10-2c0 6 3 11 1 16-6 7-13 11-22 13l-18 4c-6 0-11 2-17 3-10 1-10 1-13-8l-8-29c0-2-1-5-3-5-3-1-3 3-4 5a276 276 0 0 0-10 34c-1 4-3 5-7 7-11 4-22 6-34 5a205 205 0 0 1-17-12c-6-3-10-8-16-10-4-3-1-7-1-10l3-13c2 2 4 4 7 1 2-2 1-5-1-7l-4-6 2-6a25 25 0 0 0 2 2c2 2 4 3 6 2 2-2 1-4 0-6-2-8-1-17-2-25Z"
      />
      <path
        fill="var(--flesh)"
        d="m346 380-10 2a7 7 0 0 1-7-2c-1-2 1-4 2-5l8-11 2-6c0-2 0-4-2-4-3-1-3 1-4 3a108 108 0 0 1-6 10c-1 2-3 4-5 2-2-1-1-3-1-4 3-6 3-12 4-18s7-9 9-13c6-5 7-11 7-18l-3-23c-1-17-6-33-3-51v-7c-8-14-9-29-14-43a14 14 0 0 1 7-4c8-2 13-9 20-13 3-1 4-1 5 2 5 14 3 28 6 42 3 17 6 34 4 51a443 443 0 0 0-4 56c0 7 0 14 2 20 2 8 0 15-3 22-2 5-5 9-10 9a5 5 0 0 0-4 3ZM307 413c6-3 12-3 18-5 9-1 16-5 22-12 3 2 3 5 3 7 0 15 6 28 14 40 10 16 16 34 20 52l14 52c1 2 2 4 1 6-5 0-10-1-14 5-2 4-4 1-6-1-2-19-13-35-22-50-8-12-14-25-16-39-2-12-10-19-17-28s-13-16-17-27ZM290 99c-2 0-4 0-5 4-3 7-11 9-18 11l-10 2c-4 2-8 1-12-3l-11-11c-1-2-3-3-6-3 10-6 12-17 4-26-4-5-4-11-6-17 0-2 1-4 4-4 1 3 1 6 4 8 1-5-1-10-1-14-1-4-1-7 2-10a4 4 0 0 0 2-3c0-6 3-8 8-6 8 2 16 2 24 0s11 1 11 9l1 3c6 7 5 15 4 23 4-3 3-8 5-11 3 0 4 2 3 5-1 6-4 12-8 18a25 25 0 0 0-6 17c1 5 7 6 11 8ZM178 403c6 2 10 7 16 10a205 205 0 0 0 17 12c0 4-3 7-5 9-5 5-8 12-14 17-4 5-5 11-6 17-2 15-9 28-17 40-5 10-11 19-14 30l-1 5-2 6a4 4 0 0 1-3 3c-2 0-3-1-3-3-2-5-7-7-12-8 7-17 8-35 11-53 4-21 15-40 24-59 4-7 7-14 7-22l2-4ZM182 367l4 7c2 2 3 5 1 7-3 3-5 1-7-1-11-6-16-16-20-27-2-7 0-13 1-19 4-15 2-30 1-45a453 453 0 0 1-1-68c0-14 2-28 1-42 6-1 11 4 16 6 2 1 4 2 6 1 5-3 7 0 10 3s5 4 5-4c2 5 0 6 0 8-2 1-4-2-4 2-1 17-8 34-6 51 3 23-6 45-8 67 0 9 3 16 9 22 1 8 0 17 2 25 1 2 2 4 0 6-2 1-4 0-6-2a25 25 0 0 1-2-2c-1-4-1-7-3-9-1-1-4-2-3 0 0 5-1 11 4 14Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>